import { LayerSpecificationWithZIndex } from './types'

const layers: LayerSpecificationWithZIndex[] = [
  {
    id: 'water',
    type: 'fill',
    source: 'basemap',
    'source-layer': 'water',
    filter: ['==', '$type', 'Polygon'],
    paint: {
      'fill-color': 'rgb(194, 200, 202)',
      'fill-antialias': true,
    },
  },
  {
    id: 'landuse_residential',
    type: 'fill',
    source: 'basemap',
    'source-layer': 'landuse',
    maxzoom: 16,
    filter: ['all', ['==', 'kind', 'residential']],
    paint: {
      'fill-color': 'rgb(234, 234, 230)',
      'fill-opacity': ['interpolate', ['exponential', 0.6], ['zoom'], 8, 0.8, 9, 0.6],
    },
  },
  {
    id: 'background_forest',
    type: 'fill',
    source: 'basemap',
    'source-layer': 'landuse',
    filter: ['==', 'kind', 'wood'],
    paint: {
      'fill-color': '#528329',
    },
  },
  {
    id: 'waterway',
    type: 'line',
    source: 'basemap',
    'source-layer': 'water',
    filter: ['all', ['==', '$type', 'LineString']],
    paint: {
      'line-color': 'hsl(195, 17%, 78%)',
    },
  },
  {
    id: 'water_name',
    type: 'symbol',
    source: 'basemap',
    'source-layer': 'water',
    filter: ['==', '$type', 'LineString'],
    layout: {
      'text-field': '{name}',
      'symbol-placement': 'line',
      'text-rotation-alignment': 'map',
      'symbol-spacing': 500,
      'text-font': ['Open Sans Regular'],
      'text-size': 12,
    },
    paint: {
      'text-color': 'rgb(157,169,177)',
      'text-halo-color': 'rgb(242,243,240)',
      'text-halo-width': 1,
      'text-halo-blur': 1,
    },
  },
  {
    id: 'building',
    type: 'fill',
    source: 'basemap',
    'source-layer': 'buildings',
    minzoom: 12,
    paint: {
      'fill-color': 'rgb(234, 234, 229)',
      'fill-outline-color': 'rgb(219, 219, 218)',
      'fill-antialias': true,
    },
  },
  {
    id: 'tunnel_motorway_casing',
    type: 'line',
    source: 'basemap',
    'source-layer': 'roads',
    minzoom: 6,
    filter: ['all', ['==', '$type', 'LineString'], ['all', ['has', 'is_tunnel'], ['==', 'kind', 'motorway']]],
    layout: {
      'line-cap': 'butt',
      'line-join': 'miter',
    },
    paint: {
      'line-color': 'rgb(213, 213, 213)',
      'line-width': ['interpolate', ['exponential', 1.4], ['zoom'], 5.8, 0, 6, 3, 20, 40],
    },
  },
  {
    id: 'tunnel_motorway_inner',
    type: 'line',
    source: 'basemap',
    'source-layer': 'roads',
    minzoom: 6,
    filter: ['all', ['==', '$type', 'LineString'], ['all', ['has', 'is_tunnel'], ['==', 'kind', 'motorway']]],
    layout: {
      'line-cap': 'round',
      'line-join': 'round',
    },
    paint: {
      'line-color': 'rgb(234,234,234)',
      'line-width': ['interpolate', ['exponential', 1.4], ['zoom'], 4, 2, 6, 1.3, 20, 30],
    },
  },
  {
    id: 'aeroway-taxiway',
    type: 'line',
    source: 'basemap',
    'source-layer': 'roads',
    minzoom: 12,
    filter: ['all', ['==', 'kind', 'aeroway'], ['==', 'kind_detail', 'taxiway']],
    layout: {
      'line-cap': 'round',
      'line-join': 'round',
    },
    paint: {
      'line-color': 'hsl(0, 0%, 88%)',
      'line-width': ['interpolate', ['exponential', 1.55], ['zoom'], 13, 1.8, 20, 20],
    },
  },
  {
    id: 'aeroway-runway-casing',
    type: 'line',
    source: 'basemap',
    'source-layer': 'roads',
    minzoom: 11,
    filter: ['==', 'kind', 'aeroway'],
    layout: {
      'line-cap': 'round',
      'line-join': 'round',
    },
    paint: {
      'line-color': 'hsl(0, 0%, 88%)',
      'line-width': ['interpolate', ['exponential', 1.5], ['zoom'], 11, 4, 17, 55],
    },
  },
  {
    id: 'aeroway-area',
    type: 'fill',
    source: 'basemap',
    'source-layer': 'landuse',
    minzoom: 4,
    filter: ['==', 'kind', 'aeroway'],
    paint: {
      'fill-opacity': ['interpolate', ['linear'], ['zoom'], 13, 0, 14, 1],
      'fill-color': 'rgba(255, 255, 255, 1)',
    },
  },
  {
    id: 'aeroway-runway',
    type: 'line',
    source: 'basemap',
    'source-layer': 'roads',
    minzoom: 11,
    maxzoom: 24,
    filter: ['all', ['==', 'kind', 'aeroway'], ['==', '$type', 'LineString']],
    layout: {
      'line-cap': 'round',
      'line-join': 'round',
    },
    paint: {
      'line-color': 'rgba(255, 255, 255, 1)',
      'line-width': ['interpolate', ['exponential', 1.5], ['zoom'], 11, 4, 17, 50],
    },
  },
  {
    id: 'highway_minor',
    type: 'line',
    source: 'basemap',
    'source-layer': 'roads',
    minzoom: 8,
    filter: ['==', 'kind', 'minor_road'],
    layout: {
      'line-cap': 'round',
      'line-join': 'round',
    },
    paint: {
      'line-color': 'hsl(0, 0%, 80%)',
      'line-width': ['interpolate', ['exponential', 1.55], ['zoom'], 13, 1.8, 20, 20],
      'line-opacity': 0.9,
    },
  },
  {
    id: 'highway_major_casing',
    type: 'line',
    source: 'basemap',
    'source-layer': 'roads',
    minzoom: 11,
    filter: ['==', 'kind', 'major_road'],
    layout: {
      'line-cap': 'butt',
      'line-join': 'miter',
    },
    paint: {
      'line-color': 'rgb(213, 213, 213)',
      'line-dasharray': [12, 0],
      'line-width': ['interpolate', ['exponential', 1.3], ['zoom'], 10, 3, 20, 23],
    },
  },
  {
    id: 'highway_major_inner',
    type: 'line',
    source: 'basemap',
    'source-layer': 'roads',
    minzoom: 11,
    filter: ['==', 'kind', 'major_road'],
    layout: {
      'line-cap': 'round',
      'line-join': 'round',
    },
    paint: {
      'line-color': '#fff',
      'line-width': ['interpolate', ['exponential', 1.3], ['zoom'], 10, 2, 20, 20],
    },
  },
  {
    id: 'highway_major_subtle',
    type: 'line',
    source: 'basemap',
    'source-layer': 'roads',
    maxzoom: 11,
    filter: ['==', 'kind', 'major_road'],
    layout: {
      'line-cap': 'round',
      'line-join': 'round',
    },
    paint: {
      'line-color': 'hsla(0, 0%, 85%, 0.69)',
      'line-width': 2,
    },
  },
  {
    id: 'highway_motorway_casing',
    type: 'line',
    source: 'basemap',
    'source-layer': 'roads',
    minzoom: 6,
    filter: ['==', 'kind', 'highway'],
    layout: {
      'line-cap': 'butt',
      'line-join': 'miter',
    },
    paint: {
      'line-color': 'rgb(213, 213, 213)',
      'line-width': ['interpolate', ['exponential', 1.4], ['zoom'], 5.8, 0, 6, 3, 20, 40],
      'line-dasharray': [2, 0],
    },
  },
  {
    id: 'highway_motorway_inner',
    type: 'line',
    source: 'basemap',
    'source-layer': 'roads',
    minzoom: 6,
    filter: ['==', 'kind', 'highway'],
    layout: {
      'line-cap': 'round',
      'line-join': 'round',
    },
    paint: {
      'line-color': ['interpolate-hcl', ['linear'], ['zoom'], 6, 'hsla(0, 0%, 85%, 0.53)', 8, '#fff'],
      'line-width': ['interpolate', ['exponential', 1.4], ['zoom'], 4, 2, 6, 1.3, 20, 30],
    },
  },
  {
    id: 'highway_motorway_subtle',
    type: 'line',
    source: 'basemap',
    'source-layer': 'roads',
    maxzoom: 6,
    filter: ['==', 'kind', 'highway'],
    layout: {
      'line-cap': 'round',
      'line-join': 'round',
    },
    paint: {
      'line-color': 'hsla(0, 0%, 85%, 0.53)',
      'line-width': ['interpolate', ['exponential', 1.4], ['zoom'], 4, 2, 6, 1.3],
    },
  },
  {
    id: 'railway',
    type: 'line',
    source: 'basemap',
    'source-layer': 'roads',
    minzoom: 13,
    filter: [
      'all',
      ['==', '$type', 'LineString'],
      ['all', ['!has', 'service'], ['!has', 'is_tunnel'], ['==', 'kind', 'rail']],
    ],
    layout: {
      'line-join': 'round',
    },
    paint: {
      'line-color': '#dddddd',
      'line-width': ['interpolate', ['exponential', 1.3], ['zoom'], 9, 2, 20, 7],
    },
  },
  {
    id: 'railway_dashline',
    type: 'line',
    source: 'basemap',
    'source-layer': 'roads',
    minzoom: 13,
    filter: [
      'all',
      ['==', '$type', 'LineString'],
      ['all', ['!has', 'service'], ['!has', 'is_tunnel'], ['==', 'class', 'rail']],
    ],
    layout: {
      'line-join': 'round',
    },
    paint: {
      'line-color': '#fafafa',
      'line-width': ['interpolate', ['exponential', 1.3], ['zoom'], 9, 1, 20, 6],
      'line-dasharray': [3, 3],
    },
  },
  {
    id: 'highway_motorway_bridge_casing',
    type: 'line',
    source: 'basemap',
    'source-layer': 'roads',
    minzoom: 6,
    filter: [
      'all',
      ['==', '$type', 'LineString'],
      ['all', ['==', 'brunnel', 'bridge'], ['==', 'kind', 'motorway']],
    ],
    layout: {
      'line-cap': 'butt',
      'line-join': 'miter',
    },
    paint: {
      'line-color': 'rgb(213, 213, 213)',
      'line-width': ['interpolate', ['exponential', 1.4], ['zoom'], 5.8, 0, 6, 5, 20, 45],
      'line-dasharray': [2, 0],
    },
  },
  {
    id: 'highway_motorway_bridge_inner',
    type: 'line',
    source: 'basemap',
    'source-layer': 'roads',
    minzoom: 6,
    filter: [
      'all',
      ['==', '$type', 'LineString'],
      ['all', ['==', 'brunnel', 'bridge'], ['==', 'kind', 'motorway']],
    ],
    layout: {
      'line-cap': 'round',
      'line-join': 'round',
    },
    paint: {
      'line-color': ['interpolate-hcl', ['linear'], ['zoom'], 5.8, 'hsla(0, 0%, 85%, 0.53)', 6, '#fff'],
      'line-width': ['interpolate', ['exponential', 1.4], ['zoom'], 4, 2, 6, 1.3, 20, 30],
    },
  },
  {
    id: 'highway_name_motorway',
    type: 'symbol',
    source: 'basemap',
    'source-layer': 'roads',
    filter: ['all', ['==', '$type', 'LineString'], ['==', 'kind', 'motorway']],
    layout: {
      'text-size': 10,
      'symbol-spacing': 350,
      'text-font': ['Open Sans Regular'],
      'symbol-placement': 'line',
      'text-rotation-alignment': 'viewport',
      'text-pitch-alignment': 'viewport',
      'text-field': '{ref}',
    },
    paint: {
      'text-color': 'rgb(117, 129, 145)',
      'text-halo-color': 'hsl(0, 0%, 100%)',
      'text-translate': [0, 2],
      'text-halo-width': 1,
      'text-halo-blur': 1,
    },
  },
  {
    id: 'place_other',
    type: 'symbol',
    source: 'basemap',
    'source-layer': 'places',
    maxzoom: 14,
    filter: ['==', 'kind', 'neighbourhood'],
    layout: {
      'text-size': 10,
      'text-transform': 'uppercase',
      'text-font': ['Open Sans Regular'],
      'text-justify': 'center',
      'text-offset': [0.5, 0],
      'text-anchor': 'center',
      'text-field': '{name}',
    },
    paint: {
      'text-color': 'rgb(117, 129, 145)',
      'text-halo-color': 'rgb(242,243,240)',
      'text-halo-width': 1,
      'text-halo-blur': 1,
    },
  },
  {
    id: 'place_suburb',
    type: 'symbol',
    source: 'basemap',
    'source-layer': 'places',
    maxzoom: 15,
    filter: ['==', 'kind', 'macrohood'],
    layout: {
      'text-size': 10,
      'text-transform': 'uppercase',
      'text-font': ['Open Sans Regular'],
      'text-justify': 'center',
      'text-offset': [0.5, 0],
      'text-anchor': 'center',
      'text-field': '{name}',
    },
    paint: {
      'text-color': 'rgb(117, 129, 145)',
      'text-halo-color': 'rgb(242,243,240)',
      'text-halo-width': 1,
      'text-halo-blur': 1,
    },
  },
  {
    id: 'place_town',
    type: 'symbol',
    source: 'basemap',
    'source-layer': 'places',
    maxzoom: 15,
    filter: ['==', 'kind', 'locality'],
    layout: {
      'text-size': 10,
      'icon-image': ['step', ['zoom'], 'circle-11', 8, ''],
      'text-transform': 'uppercase',
      'text-font': ['Open Sans Regular'],
      'text-justify': 'left',
      'text-offset': [0.5, 0.2],
      'icon-size': 0.4,
      'text-anchor': ['step', ['zoom'], 'left', 8, 'center'],
      'text-field': '{name}',
    },
    paint: {
      'text-color': 'rgb(117, 129, 145)',
      'text-halo-color': 'rgb(242,243,240)',
      'text-halo-width': 1,
      'text-halo-blur': 1,
      'icon-opacity': 0.7,
    },
  },
  {
    id: 'place_city',
    type: 'symbol',
    source: 'basemap',
    'source-layer': 'places',
    maxzoom: 14,
    filter: [
      'all',
      ['==', '$type', 'Point'],
      ['all', ['!=', 'capital', 2], ['==', 'class', 'city'], ['>', 'rank', 3]],
    ],
    layout: {
      'text-size': 10,
      'icon-image': ['step', ['zoom'], 'circle-11', 8, ''],
      'text-transform': 'uppercase',
      'text-font': ['Open Sans Regular'],
      'text-justify': 'left',
      'text-offset': [0.5, 0.2],
      'icon-size': 0.4,
      'text-anchor': ['step', ['zoom'], 'left', 8, 'center'],
      'text-field': '{name}',
    },
    paint: {
      'text-color': 'rgb(117, 129, 145)',
      'text-halo-color': 'rgb(242,243,240)',
      'text-halo-width': 1,
      'text-halo-blur': 1,
      'icon-opacity': 0.7,
    },
  },
  {
    id: 'place_capital',
    type: 'symbol',
    source: 'basemap',
    'source-layer': 'places',
    maxzoom: 12,
    filter: ['all', ['==', '$type', 'Point'], ['all', ['==', 'capital', 2], ['==', 'class', 'city']]],
    layout: {
      'text-size': 14,
      'icon-image': ['step', ['zoom'], 'star-11', 8, ''],
      'text-transform': 'uppercase',
      'text-font': ['Open Sans Regular'],
      'text-justify': 'left',
      'text-offset': [0.5, 0.2],
      'icon-size': 1,
      'text-anchor': ['step', ['zoom'], 'left', 8, 'center'],
      'text-field': '{name}',
    },
    paint: {
      'text-color': 'rgb(117, 129, 145)',
      'text-halo-color': 'rgb(242,243,240)',
      'text-halo-width': 1,
      'text-halo-blur': 1,
      'icon-opacity': 0.7,
    },
  },
  {
    id: 'place_city_large',
    type: 'symbol',
    source: 'basemap',
    'source-layer': 'places',
    maxzoom: 12,
    filter: [
      'all',
      ['==', '$type', 'Point'],
      ['all', ['!=', 'capital', 2], ['<=', 'rank', 3], ['==', 'class', 'city']],
    ],
    layout: {
      'text-size': 14,
      'icon-image': ['step', ['zoom'], 'circle-11', 8, ''],
      'text-transform': 'uppercase',
      'text-font': ['Open Sans Regular'],
      'text-justify': 'left',
      'text-offset': [0.5, 0.2],
      'icon-size': 0.4,
      'text-field': '{name}',
    },
    paint: {
      'text-color': 'rgb(117, 129, 145)',
      'text-halo-color': 'rgb(242,243,240)',
      'text-halo-width': 1,
      'text-halo-blur': 1,
      'icon-opacity': 0.7,
    },
  },
]

export default layers
